import React, { Component, Suspense } from "react";
import * as ReactDOM from "react-dom";
import Slider from "react-slick";
import edit from "../image/icons/edit.png";
import plus from "../image/icons/plus.png";
import $ from "jquery";
const folderName = window.sessionStorage.getItem("homeName");

export default class Banner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: [],
      sectionName: "Banner",
    };
  }
  componentDidMount() {
    const bannerData = JSON.parse(window.sessionStorage.getItem("Banner"));
    if (bannerData) {
      this.setState({ bannerData: bannerData });
    } else {
      // window.location.reload(false);
    }
  }
  addClick (sid,pId,cId,ptitle,cTitile,cdescri,childUrl,childImg,sOrder) { 
    if($("#bannerParentId").val()!== "") {
      pId=$("#bannerParentId").val();
    }
    if(childImg){
      var splitImg=childImg.split("theme/")
      childImg=splitImg[1];
      }

    const LazyPage = React.lazy(() => import("../" + folderName + "/ThemeComponent"));
    ReactDOM.render(
      <div>
        <Suspense fallback={<div>Loading...</div>}>
          <section>
            <LazyPage
               sessionId={sid} 
               parentId={pId}
               childId={cId}
               patentTitle={ptitle}
               childTitle={cTitile}
               childDesri={cdescri}
               sectionName={this.state.sectionName}
               childUrl={childUrl}
               childImg={childImg}
               sortSubOrder={sOrder}
            />
          </section>
        </Suspense>
      </div>,
      document.getElementById("bannerpopUpBlock")
    );
    $("#bannerpopUpBlock").addClass("editActive");
  }

  render() {
   
    var settings = {
      dots: false,
      fade: true,
      infinite: false,
      autoplay: true,
      arrows: true,
      autoplaySpeed: 6000,
      pauseOnHover: false,
    };
    const urlPath = window.location.origin.toString();
    return (
      <div class="mentalBanner" id="banner">
      {this.props.themeFlag === "theme" && (
          <div className="editIconSec" id="Banner">
            <span
              className="editIcon editAddIcon"
              title="Add"
              onClick={() => this.addClick("3","","","","","","","","")}
            >
              <img src={plus} alt="Add" />
            </span>
          </div>
        )}
        <div className="cmsContentDiv" id="bannerpopUpBlock" style={{top:"0"}}></div>
        <input type="hidden" id="bannerSectionId" value="3" />

        {this.state.bannerData.map((ban) => {
          return (
            <div>
              <input type="hidden" id="bannerParentId" value={ban.parentId} />
              {ban.sectionList.length !== "0" && (
                <Slider {...settings}>
                  {ban.sectionList.map((data) => (
                    <div class="mentalBannerImage">
                      {this.props.themeFlag === "theme" && (
                        <div className="editIconSec editIconSecTop">
                          <span
                            className="editIcon editAddIcon"
                            title="Edit"
                            onClick={() =>
                              this.addClick
                              (ban.sectionId,
                                ban.parentId,
                                data.childId,
                                ban.parentName,
                                data.childName,
                                data.childDescription,
                                data.childUrl,
                                data.childImage,
                                data.homeAdsSubSortOrder)
                            }
                          >
                            <img src={edit} alt="logo" />
                          </span>
                        </div>
                      )}
                      <img src={data.childImage} alt="" className="banner-imgg" />
                      {data.childName!="@" ? (
                      <div class="banner-caption">
                        <h1>{data.childName}</h1>
                      </div>
                       ) : ''}
                    </div>
                  ))}
                </Slider>
              )}
            </div>
          );
        })}
      </div>
    );
  }
}
